/* ══ PLATFORM TRANSLATIONS ══════════════════════════════════ */
const PT = {
  en:{
    signIn:"Sign in", signUp:"Get started", createWs:"Create workspace",
    name:"Full name", email:"Email address", password:"Password",
    wsName:"Workspace name", subdomain:"Subdomain", phone:"Mobile number",
    phoneHint:"With country code, e.g. +966501234567",
    inviteCode:"Invite code", allFields:"All fields are required.",
    subdomainHint:"Lowercase letters, numbers and hyphens only.",
    invalidCode:"Invalid or already used invite code.",
    requestSubmitted:"Request submitted",
    pendingBody:"Your workspace is pending admin approval. You'll be notified once activated.",
    wsCreated:"Workspace created!",
    wsReady:"Your workspace is ready.",
    enterWs:"Enter workspace",
    back:"Back",
    inviteOnly:"Access by invitation only. Contact your administrator.",
    workspaceLabel:"Workspace",
    noWs:"No workspace? ",
    createOne:"Create one",
    incorrectPw:"Incorrect email or password.",
    wsNotFound:"Workspace not found or suspended.",
    accountSuspendedPlatform:"Your account has been suspended. Please contact support.",
    accountSuspendedOwner:"Your account has been suspended. Please contact your owner for information.",
    saTitle:"Super Admin",
    saAccess:"Admin access",
    allWorkspaces:"All Workspaces",
    pending:"Pending",
    inviteCodes:"Invite Codes",
    signupMode:"Signup Mode",
    branding:"Platform Branding",
    total:"Total", active:"Active", suspended:"Suspended",
    workspace:"Workspace", owner:"Owner", status:"Status", created:"Created", actions:"Actions",
    impersonate:"Impersonate", suspend:"Suspend", activate:"Activate",
    approve:"Approve", reject:"Reject",
    noPending:"No pending requests.",
    generateCode:"Generate Code",
    noInvites:"No invite codes generated.",
    code:"Code", used:"Used",
    openSignup:"Open Signup", approvalRequired:"Approval Required", inviteOnly2:"Invite Only",
    openDesc:"Anyone can create a workspace immediately.",
    approvalDesc:"Users request a workspace; a super admin must approve.",
    inviteDesc:"New workspaces require a valid invite code.",
    platformName:"Platform name", tagline:"Tagline", anchorColor:"Anchor color",
    logo:"Logo", colorPresets:"Color presets",
    newSaPw:"New super admin password", keepCurrent:"(leave blank to keep current)",
    savePlatform:"Save platform settings", saved:"Saved ✓",
    logoHint:"Shown on landing, signup and login pages.",
    preAssign:"Email to pre-assign (optional)",
    exitAdmin:"Exit admin", impersonating:"Impersonating workspace:",
    exitImpersonation:"Exit impersonation",
    saLogin:"Admin login",
    requestWs:"Request workspace",
    available:"Available",
    demoComingSoon:"Demo video coming soon",
    demoNotUploaded:"The platform administrator has not uploaded a demo video yet.",
    mostPopular:"MOST POPULAR", byInvitation:"BY INVITATION",
    // SuperAdminPanel
    noWorkspacesYet:"No workspaces yet",
    editWorkspace:"Edit Workspace", ownerName:"Owner Name",
    ownerEmail:"Owner Email", ownerPhone:"Owner Phone",
    plan:"Plan", free:"Free", trial:"Trial",
    planStatus:"Plan Status", billingCycle:"Billing Cycle",
    monthly:"Monthly", yearly:"Yearly", billingStart:"Billing Start",
    save:"Save", cancel:"Cancel", remove:"Remove", reprovision:"Re-provision",
    ownerLbl:"Owner:", emailLbl:"Email:", phoneLbl:"Phone:",
    planLbl:"Plan:", billingLbl:"Billing:", createdLbl:"Created:",
    deletedLbl:"Deleted:",
    deleteConfirm:"Delete? All data lost instantly.",
    yesDelete:"Yes, delete",
    verificationRequirements:"Verification Requirements",
    warning:"Warning",
    whatsappTemplateHint:"WhatsApp verification template name",
    noDeletedInWindow:"No deleted workspaces in the retention window.",
    workspaceSettings:"Workspace Settings",
    platformWideOverrides:"Platform-wide overrides",
    module:"Module", customName:"Custom Name",
    customSubtitle:"Custom Subtitle", mobileLabel:"Mobile Label",
    changesAutoSave:"Changes save automatically and reflect immediately across all workspaces.",
    nameLabel:"Name", actionLabel:"Action", descriptionLabel:"Description",
    title:"Title", security:"Security",
    resetToDefaults:"Reset to defaults",
    defaultPriority:"Default Priority", defaultAssigneeRole:"Default Assignee Role",
    mediumPriority:"Medium", highPriority:"High", urgentPriority:"Urgent",
    userProfiles:"User Profiles", platformWideProfiles:"Platform-wide profiles",
    parentLabel:"Parent", categoryName:"Category name",
    displayLabel:"Display label", modulesIncluded:"Modules included",
    freePeriod:"Free period",
    moyasarPublishableKey:"Moyasar — Publishable Key",
    moyasarSecretKey:"Moyasar — Secret Key",
    anthropicClaude:"Anthropic (Claude)",
    googleMapsPlaces:"Google Maps (Places)",
    phoneNumberId:"Phone Number ID",
    addProfile:"Add Profile", profileNamePh:"Profile name",
    noGroup:"No group", familyGroup:"Family", staffGroup:"Staff",
    wsNotifTemplates:"Workspace Notification Templates",
    systemEmails:"System emails", subjectLabel:"Subject",
    defaultCategories:"Default Categories",
    platformWideDefaults:"Platform-wide defaults",
    addNew:"Add New", categoryNamePh:"Category name",
    arabicName:"Arabic Name", topLevelOpt:"Top-level",
    finType:"Fin. Type", subTypeLabel:"Sub-type",
    packages:"Packages", aboutPackages:"About packages",
    newPackage:"New Package", currency:"Currency",
    shortDescPh:"Short description shown on signup",
    savePackage:"Save Package",
    popularTag:"POPULAR", inviteOnlyTag:"INVITE ONLY",
    modulesHiddenTag:"MODULES HIDDEN",
    paymentCollection:"Payment collection",
    billingCycleOptions:"Billing cycle options",
    globalFreeTrialPeriod:"Global free trial period",
    promoCodes:"Promo codes", codeExpiry:"Code expiry",
    generateCodeBtn:"Generate code", addCode:"Add code",
    promoCodeAdded:"Promo code added.",
    codeLabel:"Code", labelLabel:"Label",
    expiresLbl:"Expires", usedStatus:"Used", expiredStatus:"Expired",
    activeStatus:"Active", noPromoCodes:"No promo codes yet.",
    platformApiKeys:"Platform API Keys",
    howPlatformKeys:"How platform keys work",
    aiWorkspace:"AI Workspace", clearBtn:"Clear",
    paymentGateway:"Payment Gateway",
    globalStockProvider:"Global Stock Provider",
    groceryIntelligence:"Grocery Intelligence",
    securityNote:"Security Note",
    notificationProviders:"Notification Providers",
    howItWorks:"How it works",
    emailProvider:"Email Provider", apiKeysDocs:"API keys docs",
    whatsappProvider:"WhatsApp Provider",
    docsLbl:"Docs:", enablePushDelivery:"Enable push delivery",
    firebaseConsole:"Firebase Console",
    serviceAccounts:"Service accounts",
    generateNewPrivateKey:"Generate new private key",
    vercelLbl:"Vercel", envVars:"Environment Variables",
    notificationEvents:"Notification Events",
    platformWideEventControl:"Platform-wide event control",
    recipientRoles:"Recipient Roles",
    recipientRolesHint:"Select which roles receive this notification across all workspaces.",
    parametersLbl:"Parameters",
    resetToDefault:"Reset to Default",
    previewSampleData:"Preview with sample data:",
    metaWhatsappMgr:"Meta WhatsApp Manager",
    saveConfiguration:"Save Configuration",
    sendTestEmail:"Send Test Email", sendTo:"Send to",
    templateLbl:"Template",
    verificationCodeTpl:"Verification Code",
    accountSuspendedTpl:"Account Suspended",
    workspaceUrlChangedTpl:"Workspace URL Changed",
    sendTestWhatsapp:"Send Test WhatsApp",
    generalBranding:"General Branding",
    landingPageSettings:"Landing Page Settings",
    superAdminSettings:"Super Admin Settings",
    apiKeysNotifProviders:"API Keys & Notification Providers",
    defaultCurrency:"Default Currency",
    investmentNotifDefaults:"Investment Notification Defaults",
    interestPaymentDue:"Interest payment due",
    liabilityMaturity:"Liability maturity",
    customOpt:"Custom", anchorColor:"Anchor Color",
    generatedPalette:"Generated Palette",
    platformThemeMode:"Platform Theme Mode",
    themeHint:"Applies to landing page, legal pages, signup & login screens.",
    typography:"Typography",
    fontsHint:"Fonts used on the landing page, legal pages, and signup screens.",
    headingFont:"Heading Font", bodyFont:"Body Font",
    systemDefault:"System Default", headingPreview:"Heading Preview",
    workspaceDefaults:"Workspace Defaults",
    themeMode:"Theme Mode",
    heroSection:"Hero Section", draftMode:"Draft mode",
    heroImage:"Hero Image",
    lightModeImage:"LIGHT MODE IMAGE", darkModeImage:"DARK MODE IMAGE",
    demoVideo:"Demo Video",
    featuresSection:"Features Section",
    sectionHeadingPh:"Built for outcomes, not features",
    subHeading:"Sub-heading",
    subHeadingPh:"Command gives you complete control…",
    titlePh:"Title", descriptionPh:"Description",
    showcaseSections:"Showcase Sections",
    pricingFinalCta:"Pricing & Final CTA", pricingLbl:"Pricing",
    pricingHeading:"Pricing heading",
    pricingHeadingPh:"Simple, transparent pricing",
    pricingSubHeading:"Pricing sub-heading",
    pricingSubHeadingPh:"Start free. Scale when you're ready.",
    finalCtaHeading:"Final CTA heading",
    finalCtaHeadingPh:"Take Control of Your Household",
    finalCtaSubHeading:"Final CTA sub-heading",
    finalCtaSubHeadingPh:"Join hundreds of households…",
    finalCtaButtonText:"Final CTA button text",
    finalCtaButtonPh:"Start Free Trial",
    legalPages:"Legal Pages", publicPages:"Public pages",
    companyName:"Company Name", companyNamePh:"Command Platform",
    contactEmail:"Contact Email", companyAddress:"Company Address",
    companyAddressPh:"Riyadh, Kingdom of Saudi Arabia",
    saveLegalPages:"Save Legal Pages",
    superAdminEmail:"Super Admin Email",
    adminDashboardMode:"Admin Dashboard Mode",
    aiAgentConfig:"AI Agent Configuration",
    modelLbl:"Model", maxTokens:"Max Tokens",
    defaultPrompt:"Default Prompt",
    defaultPromptPh:"Default prompt when user clicks Ask AI",
    systemPromptLbl:"System Prompt",
    systemPromptPh:"System instructions for the AI agent",
    suggestedPromptsLbl:"Suggested Prompts",
    suggestedPromptPh:"Add a suggested prompt…",
    arabicLabel:"Arabic",
    menuPlanningSettings:"Menu Planning Settings",
    defaultVotingMode:"Default Voting Mode",
    votingModeHint:"How household members vote for the weekly menu. Workspaces can override this.",
    defaultCoursesPerMeal:"Default Courses per Meal Type",
    coursesPerMealHint:"Which courses are included in each meal type by default. Workspaces can override",
    defaultVotingDeadline:"Default Voting Deadline",
    dayOfWeek:"Day of week",
    availablePreferences:"Available Preferences",
    newPreferencePh:"New preference…",
    defaultProfilePerms:"Default Profile Permissions",
    castVotes:"Cast Votes", finalizeMenu:"Finalize Menu",
    staffPermsRoles:"Staff Permissions & Roles",
    defaultStaffPerms:"Default Staff Permissions",
    defaultStaffRoles:"Default Staff Roles",
    staffRolesHint:"New workspaces start with these roles in their staff module.",
    newRoleNamePh:"New role name…", addRoleBtn:"Add Role",
    groceryTaskExpenseDefaults:"Grocery Task & Expense Defaults",
    autoCreateTaskGrocery:"Auto-create task on grocery submission",
    autoCreateTaskHint:"Each grocery request creates a task with tracking in the task engine",
    requireExpenseFulfillment:"Require expense on fulfillment",
    requireApprovalGrocery:"Require approval before grocery run",
    requireApprovalHint:"Grocery tasks start as 'pending' until approved by an authorized role",
    defaultApprovalRoles:"Default Approval Roles",
    approvalRolesHint:"Which roles can approve grocery runs. Owner is always included.",
    defaultExpenseCategory:"Default Expense Category",
    categoryLbl:"Category", subcategoryLbl:"Subcategory",
    slaSettings:"SLA Settings",
    slaGroceryHint:"Service-level targets for grocery tasks. Workspace owners can override.",
    facilityPermsConfig:"Facility Permissions & Config",
    defaultFacilityPerms:"Default Facility Permissions",
    defaultAssignableRoles:"Default Assignable Roles",
    defaultMaintenanceCategories:"Default Maintenance Categories",
    newCategoryShortPh:"New category…", addCategory:"Add Category",
    defaultIssueKinds:"Default Issue Kinds",
    newKindPh:"New kind…", addKind:"Add Kind",
    taskEngineDefaults:"Task Engine Defaults",
    autoCreateTaskIssue:"Auto-create task on issue creation",
    autoCreateTaskIssueHint:"Creates a task with SLA tracking & escalation for every new facility issue",
    requireApprovalWork:"Require approval before work begins",
    requireExpenseCompletion:"Require expense on completion",
    slaFacilityHint:"Service-level targets for facility tasks. Workspace owners can override.",
    scheduleLeadDays:"Schedule Lead Days",
    roomPresets:"Room Presets",
    roomNamePh:"Room name", arabicNamePh:"Arabic name",
    addItemEnterPh:"Add item + Enter",
    transportPermsConfig:"Transport Permissions & Config",
    defaultTransportPerms:"Default Transport Permissions",
    transportAssignableHint:"Which roles can be assigned as driver for transport rides.",
    autoCreateTask:"Auto-create task",
    autoCreateTaskTransport:"Create a task in the task engine for each transport booking",
    requireApprovalBtn:"Require approval",
    requireApprovalTransport:"Transport tasks need approval before proceeding",
    approvalRoles:"Approval Roles",
    requireExpense:"Require expense",
    requireExpenseTransport:"Expense must be logged when a ride is completed",
    fleetPermsConfig:"Fleet Permissions & Config",
    defaultFleetPerms:"Default Fleet Permissions",
    alertNotifRules:"Alert & Notification Rules",
    autoCreateTaskService:"Auto-create task when service is due",
    autoCreateTaskServiceHint:"Creates a task in the task engine when vehicle service is due",
    defaultMaintExpCat:"Default Maintenance Expense Category",
    projectPermsConfig:"Project Permissions & Config",
    defaultProjectPerms:"Default Project Permissions",
    ownerFullAccessHint:"Owner always has full access. Workspace owners can override these defaults.",
    incomePermsConfig:"Income Permissions & Config",
    defaultIncomePerms:"Default Income Permissions",
    incomeNotifDefaults:"Income Notification Defaults",
    unrealisedIncomeOverdue:"Unrealised income overdue",
    expensePermsConfig:"Expense Permissions & Config",
    defaultExpensePerms:"Default Expense Permissions",
    expenseNotifDefaults:"Expense Notification Defaults",
    budgetWarningAt:"Budget warning at",
    investmentPermsConfig:"Investment Permissions & Config",
    defaultInvestmentPerms:"Default Investment Permissions",
    defaultInvestmentCategories:"Default Investment Categories",
    listedLbl:"Listed", liquidityLbl:"Liquidity",
    dataBackup:"Data & Backup", exportAllData:"Export all data",
    importantLbl:"Important",
    downloadBackupJson:"Download Backup JSON",
    restoreFromBackup:"Restore from backup",
  },
  ar:{
    signIn:"تسجيل الدخول", signUp:"ابدأ الآن", createWs:"إنشاء مساحة عمل",
    name:"الاسم الكامل", email:"البريد الإلكتروني", password:"كلمة المرور",
    wsName:"اسم مساحة العمل", subdomain:"النطاق الفرعي", phone:"رقم الجوال",
    phoneHint:"مع رمز الدولة، مثال: +966501234567",
    inviteCode:"رمز الدعوة", allFields:"جميع الحقول مطلوبة.",
    subdomainHint:"أحرف صغيرة وأرقام وشرطات فقط.",
    invalidCode:"الرمز غير صالح أو مستخدم مسبقاً.",
    requestSubmitted:"تم إرسال الطلب",
    pendingBody:"طلب مساحة العمل الخاصة بك قيد المراجعة. ستُبلَّغ عند التفعيل.",
    wsCreated:"تم إنشاء مساحة العمل!",
    wsReady:"مساحة عملك جاهزة.",
    enterWs:"ادخل مساحة العمل",
    back:"رجوع",
    inviteOnly:"الوصول بالدعوة فقط. تواصل مع المسؤول.",
    workspaceLabel:"مساحة العمل",
    noWs:"ليس لديك مساحة عمل؟ ",
    createOne:"أنشئ واحدة",
    incorrectPw:"البريد أو كلمة المرور غير صحيحة.",
    wsNotFound:"مساحة العمل غير موجودة أو موقوفة.",
    accountSuspendedPlatform:"تم تعليق حسابك. يرجى التواصل مع الدعم.",
    accountSuspendedOwner:"تم تعليق حسابك. يرجى التواصل مع مالك مساحة العمل للاستفسار.",
    saTitle:"المسؤول العام",
    saAccess:"وصول المسؤول",
    allWorkspaces:"جميع مساحات العمل",
    pending:"في الانتظار",
    inviteCodes:"رموز الدعوة",
    signupMode:"طريقة التسجيل",
    branding:"هوية المنصة",
    total:"الإجمالي", active:"نشط", suspended:"موقوف",
    workspace:"مساحة العمل", owner:"المالك", status:"الحالة", created:"تاريخ الإنشاء", actions:"الإجراءات",
    impersonate:"محاكاة", suspend:"إيقاف", activate:"تفعيل",
    approve:"موافقة", reject:"رفض",
    noPending:"لا توجد طلبات معلقة.",
    generateCode:"إنشاء رمز",
    noInvites:"لم يتم إنشاء رموز دعوة.",
    code:"الرمز", used:"مستخدم",
    openSignup:"تسجيل مفتوح", approvalRequired:"يتطلب موافقة", inviteOnly2:"بالدعوة فقط",
    openDesc:"يمكن لأي شخص إنشاء مساحة عمل فوراً.",
    approvalDesc:"يطلب المستخدم مساحة عمل ويوافق عليها المسؤول.",
    inviteDesc:"تتطلب مساحات العمل الجديدة رمز دعوة صالحاً.",
    platformName:"اسم المنصة", tagline:"الشعار", anchorColor:"اللون الأساسي",
    logo:"الشعار", colorPresets:"ألوان جاهزة",
    newSaPw:"كلمة مرور المسؤول الجديدة", keepCurrent:"(اتركها فارغة للإبقاء على الحالية)",
    savePlatform:"حفظ إعدادات المنصة", saved:"تم الحفظ ✓",
    logoHint:"يظهر في صفحات الدخول والتسجيل.",
    preAssign:"بريد لتخصيصه مسبقاً (اختياري)",
    exitAdmin:"خروج من الإدارة", impersonating:"محاكاة مساحة العمل:",
    exitImpersonation:"إنهاء المحاكاة",
    saLogin:"تسجيل دخول المسؤول",
    requestWs:"طلب مساحة عمل",
    available:"متاح",
    demoComingSoon:"فيديو توضيحي قريباً",
    demoNotUploaded:"لم يقم مسؤول المنصة برفع الفيديو التوضيحي بعد.",
    mostPopular:"الأكثر شعبية", byInvitation:"بالدعوة فقط",
    // SuperAdminPanel
    noWorkspacesYet:"لا توجد مساحات عمل بعد",
    editWorkspace:"تعديل مساحة العمل", ownerName:"اسم المالك",
    ownerEmail:"بريد المالك", ownerPhone:"هاتف المالك",
    plan:"الخطة", free:"مجاني", trial:"تجريبي",
    planStatus:"حالة الخطة", billingCycle:"دورة الفوترة",
    monthly:"شهري", yearly:"سنوي", billingStart:"بداية الفوترة",
    save:"حفظ", cancel:"إلغاء", remove:"حذف", reprovision:"إعادة التهيئة",
    ownerLbl:"المالك:", emailLbl:"البريد:", phoneLbl:"الهاتف:",
    planLbl:"الخطة:", billingLbl:"الفوترة:", createdLbl:"أُنشئت:",
    deletedLbl:"حُذفت:",
    deleteConfirm:"هل تريد الحذف؟ ستُفقد جميع البيانات فوراً.",
    yesDelete:"نعم، احذف",
    verificationRequirements:"متطلبات التحقق",
    warning:"تحذير",
    whatsappTemplateHint:"اسم قالب تحقق واتساب",
    noDeletedInWindow:"لا توجد مساحات عمل محذوفة ضمن فترة الاحتفاظ.",
    workspaceSettings:"إعدادات مساحة العمل",
    platformWideOverrides:"تجاوزات على مستوى المنصة",
    module:"الوحدة", customName:"الاسم المخصص",
    customSubtitle:"العنوان الفرعي المخصص", mobileLabel:"التسمية للجوال",
    changesAutoSave:"تُحفظ التغييرات تلقائياً وتنعكس فوراً على جميع مساحات العمل.",
    nameLabel:"الاسم", actionLabel:"الإجراء", descriptionLabel:"الوصف",
    title:"العنوان", security:"الأمان",
    resetToDefaults:"إعادة تعيين إلى الافتراضي",
    defaultPriority:"الأولوية الافتراضية", defaultAssigneeRole:"دور المُكلَّف الافتراضي",
    mediumPriority:"متوسطة", highPriority:"عالية", urgentPriority:"عاجلة",
    userProfiles:"ملفات المستخدمين", platformWideProfiles:"ملفات على مستوى المنصة",
    parentLabel:"الأصل", categoryName:"اسم الفئة",
    displayLabel:"التسمية المعروضة", modulesIncluded:"الوحدات المشمولة",
    freePeriod:"الفترة المجانية",
    moyasarPublishableKey:"Moyasar — المفتاح العام",
    moyasarSecretKey:"Moyasar — المفتاح السري",
    anthropicClaude:"Anthropic (Claude)",
    googleMapsPlaces:"Google Maps (Places)",
    phoneNumberId:"معرّف رقم الهاتف",
    addProfile:"إضافة ملف", profileNamePh:"اسم الملف",
    noGroup:"بلا مجموعة", familyGroup:"العائلة", staffGroup:"الموظفون",
    wsNotifTemplates:"قوالب إشعارات مساحة العمل",
    systemEmails:"رسائل النظام", subjectLabel:"الموضوع",
    defaultCategories:"الفئات الافتراضية",
    platformWideDefaults:"افتراضيات على مستوى المنصة",
    addNew:"إضافة جديد", categoryNamePh:"اسم الفئة",
    arabicName:"الاسم بالعربية", topLevelOpt:"المستوى الأعلى",
    finType:"النوع المالي", subTypeLabel:"النوع الفرعي",
    packages:"الباقات", aboutPackages:"عن الباقات",
    newPackage:"باقة جديدة", currency:"العملة",
    shortDescPh:"وصف قصير يظهر عند التسجيل",
    savePackage:"حفظ الباقة",
    popularTag:"شائعة", inviteOnlyTag:"بالدعوة فقط",
    modulesHiddenTag:"الوحدات مخفية",
    paymentCollection:"تحصيل المدفوعات",
    billingCycleOptions:"خيارات دورة الفوترة",
    globalFreeTrialPeriod:"فترة التجربة المجانية العامة",
    promoCodes:"رموز العروض", codeExpiry:"انتهاء الرمز",
    generateCodeBtn:"إنشاء رمز", addCode:"إضافة رمز",
    promoCodeAdded:"تمت إضافة رمز العرض.",
    codeLabel:"الرمز", labelLabel:"التسمية",
    expiresLbl:"ينتهي", usedStatus:"مُستخدم", expiredStatus:"منتهي",
    activeStatus:"نشط", noPromoCodes:"لا توجد رموز عروض بعد.",
    platformApiKeys:"مفاتيح API للمنصة",
    howPlatformKeys:"كيف تعمل مفاتيح المنصة",
    aiWorkspace:"مساحة الذكاء الاصطناعي", clearBtn:"مسح",
    paymentGateway:"بوابة الدفع",
    globalStockProvider:"مزود الأسهم العالمية",
    groceryIntelligence:"ذكاء البقالة",
    securityNote:"ملاحظة أمنية",
    notificationProviders:"مزودو الإشعارات",
    howItWorks:"كيف يعمل",
    emailProvider:"مزود البريد الإلكتروني", apiKeysDocs:"وثائق مفاتيح API",
    whatsappProvider:"مزود واتساب",
    docsLbl:"الوثائق:", enablePushDelivery:"تفعيل تسليم الإشعارات",
    firebaseConsole:"Firebase Console",
    serviceAccounts:"حسابات الخدمة",
    generateNewPrivateKey:"إنشاء مفتاح خاص جديد",
    vercelLbl:"Vercel", envVars:"متغيرات البيئة",
    notificationEvents:"أحداث الإشعارات",
    platformWideEventControl:"التحكم في الأحداث على مستوى المنصة",
    recipientRoles:"أدوار المستلمين",
    recipientRolesHint:"اختر الأدوار التي تتلقى هذا الإشعار عبر جميع مساحات العمل.",
    parametersLbl:"المعلمات",
    resetToDefault:"إعادة إلى الافتراضي",
    previewSampleData:"معاينة ببيانات تجريبية:",
    metaWhatsappMgr:"مدير Meta واتساب",
    saveConfiguration:"حفظ الإعدادات",
    sendTestEmail:"إرسال بريد تجريبي", sendTo:"إرسال إلى",
    templateLbl:"القالب",
    verificationCodeTpl:"رمز التحقق",
    accountSuspendedTpl:"الحساب موقوف",
    workspaceUrlChangedTpl:"تم تغيير عنوان مساحة العمل",
    sendTestWhatsapp:"إرسال واتساب تجريبي",
    generalBranding:"الهوية العامة",
    landingPageSettings:"إعدادات صفحة الهبوط",
    superAdminSettings:"إعدادات المسؤول العام",
    apiKeysNotifProviders:"مفاتيح API ومزودو الإشعارات",
    defaultCurrency:"العملة الافتراضية",
    investmentNotifDefaults:"افتراضيات إشعارات الاستثمار",
    interestPaymentDue:"استحقاق دفع الفائدة",
    liabilityMaturity:"استحقاق الخصم",
    customOpt:"مخصص", anchorColor:"اللون الأساسي",
    generatedPalette:"اللوحة المولّدة",
    platformThemeMode:"وضع ثيم المنصة",
    themeHint:"يُطبَّق على صفحة الهبوط والصفحات القانونية وشاشات التسجيل والدخول.",
    typography:"الطباعة",
    fontsHint:"الخطوط المستخدمة في صفحة الهبوط والصفحات القانونية وشاشات التسجيل.",
    headingFont:"خط العناوين", bodyFont:"خط النص",
    systemDefault:"افتراضي النظام", headingPreview:"معاينة العنوان",
    workspaceDefaults:"افتراضيات مساحة العمل",
    themeMode:"وضع الثيم",
    heroSection:"القسم الرئيسي", draftMode:"وضع المسودة",
    heroImage:"صورة القسم الرئيسي",
    lightModeImage:"صورة الوضع الفاتح", darkModeImage:"صورة الوضع الداكن",
    demoVideo:"فيديو توضيحي",
    featuresSection:"قسم الميزات",
    sectionHeadingPh:"مبني للنتائج، لا للميزات",
    subHeading:"العنوان الفرعي",
    subHeadingPh:"Command يمنحك التحكم الكامل…",
    titlePh:"العنوان", descriptionPh:"الوصف",
    showcaseSections:"أقسام العرض",
    pricingFinalCta:"الأسعار والدعوة النهائية", pricingLbl:"الأسعار",
    pricingHeading:"عنوان الأسعار",
    pricingHeadingPh:"أسعار بسيطة وشفافة",
    pricingSubHeading:"عنوان فرعي للأسعار",
    pricingSubHeadingPh:"ابدأ مجاناً. وسّع عندما تكون جاهزاً.",
    finalCtaHeading:"عنوان الدعوة النهائية",
    finalCtaHeadingPh:"تحكم في منزلك",
    finalCtaSubHeading:"عنوان فرعي للدعوة النهائية",
    finalCtaSubHeadingPh:"انضم إلى مئات الأسر…",
    finalCtaButtonText:"نص زر الدعوة النهائية",
    finalCtaButtonPh:"ابدأ تجربة مجانية",
    legalPages:"الصفحات القانونية", publicPages:"الصفحات العامة",
    companyName:"اسم الشركة", companyNamePh:"منصة Command",
    contactEmail:"بريد التواصل", companyAddress:"عنوان الشركة",
    companyAddressPh:"الرياض، المملكة العربية السعودية",
    saveLegalPages:"حفظ الصفحات القانونية",
    superAdminEmail:"بريد المسؤول العام",
    adminDashboardMode:"وضع لوحة تحكم المسؤول",
    aiAgentConfig:"إعداد وكيل الذكاء الاصطناعي",
    modelLbl:"النموذج", maxTokens:"الحد الأقصى للرموز",
    defaultPrompt:"التوجيه الافتراضي",
    defaultPromptPh:"التوجيه الافتراضي عند الضغط على اسأل",
    systemPromptLbl:"توجيه النظام",
    systemPromptPh:"تعليمات النظام لوكيل الذكاء الاصطناعي",
    suggestedPromptsLbl:"التوجيهات المقترحة",
    suggestedPromptPh:"أضف توجيهاً مقترحاً…",
    arabicLabel:"العربية",
    menuPlanningSettings:"إعدادات تخطيط القائمة",
    defaultVotingMode:"وضع التصويت الافتراضي",
    votingModeHint:"كيف يصوّت أفراد المنزل للقائمة الأسبوعية. يمكن لمساحات العمل التجاوز.",
    defaultCoursesPerMeal:"الأطباق الافتراضية لكل وجبة",
    coursesPerMealHint:"الأطباق المشمولة في كل نوع وجبة افتراضياً. يمكن لمساحات العمل التجاوز",
    defaultVotingDeadline:"الموعد النهائي الافتراضي للتصويت",
    dayOfWeek:"يوم من الأسبوع",
    availablePreferences:"التفضيلات المتاحة",
    newPreferencePh:"تفضيل جديد…",
    defaultProfilePerms:"صلاحيات الملف الافتراضية",
    castVotes:"الإدلاء بالأصوات", finalizeMenu:"اعتماد القائمة",
    staffPermsRoles:"صلاحيات الموظفين والأدوار",
    defaultStaffPerms:"صلاحيات الموظفين الافتراضية",
    defaultStaffRoles:"أدوار الموظفين الافتراضية",
    staffRolesHint:"تبدأ مساحات العمل الجديدة بهذه الأدوار في وحدة الموظفين.",
    newRoleNamePh:"اسم دور جديد…", addRoleBtn:"إضافة دور",
    groceryTaskExpenseDefaults:"افتراضيات مهام ومصروفات البقالة",
    autoCreateTaskGrocery:"إنشاء مهمة تلقائياً عند طلب البقالة",
    autoCreateTaskHint:"كل طلب بقالة يُنشئ مهمة مع التتبع في محرك المهام",
    requireExpenseFulfillment:"اشتراط تسجيل مصروف عند الإكمال",
    requireApprovalGrocery:"اشتراط موافقة قبل تنفيذ البقالة",
    requireApprovalHint:"تبدأ مهام البقالة بحالة 'معلقة' حتى تُعتمد من دور مخوّل",
    defaultApprovalRoles:"أدوار الموافقة الافتراضية",
    approvalRolesHint:"الأدوار التي يمكنها الموافقة على رحلات البقالة. المالك مضمّن دائماً.",
    defaultExpenseCategory:"فئة المصروف الافتراضية",
    categoryLbl:"الفئة", subcategoryLbl:"الفئة الفرعية",
    slaSettings:"إعدادات SLA",
    slaGroceryHint:"أهداف مستوى الخدمة لمهام البقالة. يمكن لمالكي مساحة العمل التجاوز.",
    facilityPermsConfig:"صلاحيات وإعداد المرافق",
    defaultFacilityPerms:"صلاحيات المرافق الافتراضية",
    defaultAssignableRoles:"الأدوار القابلة للتعيين افتراضياً",
    defaultMaintenanceCategories:"فئات الصيانة الافتراضية",
    newCategoryShortPh:"فئة جديدة…", addCategory:"إضافة فئة",
    defaultIssueKinds:"أنواع المشاكل الافتراضية",
    newKindPh:"نوع جديد…", addKind:"إضافة نوع",
    taskEngineDefaults:"افتراضيات محرك المهام",
    autoCreateTaskIssue:"إنشاء مهمة تلقائياً عند إنشاء مشكلة",
    autoCreateTaskIssueHint:"يُنشئ مهمة مع تتبع SLA والتصعيد لكل مشكلة مرافق جديدة",
    requireApprovalWork:"اشتراط موافقة قبل بدء العمل",
    requireExpenseCompletion:"اشتراط مصروف عند الإكمال",
    slaFacilityHint:"أهداف مستوى الخدمة لمهام المرافق. يمكن لمالكي مساحة العمل التجاوز.",
    scheduleLeadDays:"أيام تمهيد الجدولة",
    roomPresets:"إعدادات الغرف",
    roomNamePh:"اسم الغرفة", arabicNamePh:"الاسم بالعربية",
    addItemEnterPh:"أضف عنصر + Enter",
    transportPermsConfig:"صلاحيات وإعداد النقل",
    defaultTransportPerms:"صلاحيات النقل الافتراضية",
    transportAssignableHint:"الأدوار التي يمكن تعيينها كسائق لرحلات النقل.",
    autoCreateTask:"إنشاء مهمة تلقائياً",
    autoCreateTaskTransport:"إنشاء مهمة في محرك المهام لكل حجز نقل",
    requireApprovalBtn:"اشتراط الموافقة",
    requireApprovalTransport:"تحتاج مهام النقل إلى موافقة قبل المتابعة",
    approvalRoles:"أدوار الموافقة",
    requireExpense:"اشتراط المصروف",
    requireExpenseTransport:"يجب تسجيل مصروف عند إكمال الرحلة",
    fleetPermsConfig:"صلاحيات وإعداد الأسطول",
    defaultFleetPerms:"صلاحيات الأسطول الافتراضية",
    alertNotifRules:"قواعد التنبيهات والإشعارات",
    autoCreateTaskService:"إنشاء مهمة تلقائياً عند استحقاق الصيانة",
    autoCreateTaskServiceHint:"يُنشئ مهمة في محرك المهام عند استحقاق صيانة المركبة",
    defaultMaintExpCat:"فئة مصروف الصيانة الافتراضية",
    projectPermsConfig:"صلاحيات وإعداد المشاريع",
    defaultProjectPerms:"صلاحيات المشاريع الافتراضية",
    ownerFullAccessHint:"المالك لديه دائماً صلاحية كاملة. يمكن لمالكي مساحة العمل تجاوز هذه الافتراضيات.",
    incomePermsConfig:"صلاحيات وإعداد الدخل",
    defaultIncomePerms:"صلاحيات الدخل الافتراضية",
    incomeNotifDefaults:"افتراضيات إشعارات الدخل",
    unrealisedIncomeOverdue:"دخل غير محقق متأخر",
    expensePermsConfig:"صلاحيات وإعداد المصروفات",
    defaultExpensePerms:"صلاحيات المصروفات الافتراضية",
    expenseNotifDefaults:"افتراضيات إشعارات المصروفات",
    budgetWarningAt:"تحذير الميزانية عند",
    investmentPermsConfig:"صلاحيات وإعداد الاستثمار",
    defaultInvestmentPerms:"صلاحيات الاستثمار الافتراضية",
    defaultInvestmentCategories:"فئات الاستثمار الافتراضية",
    listedLbl:"مدرج", liquidityLbl:"السيولة",
    dataBackup:"البيانات والنسخ الاحتياطي", exportAllData:"تصدير جميع البيانات",
    importantLbl:"مهم",
    downloadBackupJson:"تحميل نسخة احتياطية JSON",
    restoreFromBackup:"استعادة من نسخة احتياطية",
  },
};

export default PT;
